module.exports = __webpack_public_path__ + "media/iphone-ringtone.e71437b0.mp3";